/**
 * Game input limits — must stay in sync with
 * justsomeguy-backend/src/validation/gameValidation.js
 */
export const LIMITS = {
  GAME_NAME_MAX: 100,
  OBJECTIVE_MAX: 1000,
  SCENE_DESCRIPTION_MAX: 1000,
  TOTAL_PLAYERS_MAX: 10,
  AI_PLAYERS_MAX: 8,
  HUMAN_PLAYERS_MAX: 4,
  MAX_ROUNDS: 25,
  MAX_MESSAGES_PER_ROUND: 50,
  PLAYER_NAME_MAX: 60,
  CHARACTER_DESCRIPTION_MAX: 500,
  PLAYER_OBJECTIVE_MAX: 500,
  SECRET_INFO_MAX: 500,
  CHAT_MESSAGE_MAX: 2000,
  THOUGHTS_MAX: 1000,
  SPECTATOR_MESSAGE_MAX: 500,
  INTERJECTION_MAX: 2000,
  SENDER_NAME_MAX: 60,
  REACTION_MAX: 10,
};
